import { Typography } from '@mui/material';
import React from 'react';

interface Props {
  text: string;
}

const HeaderTypography: React.FC<Props> = ({ text }: Props) => {
  return (
    <Typography
      variant="h1"
      sx={{
        fontWeight: 500,
        fontSize: { mobile: 33, tablet: 44 },
        pb: { mobile: 0.5, tablet: 1 },
        lineHeight: { mobile: '48px', desktop: '56px' },
        letterSpacing: { mobile: '.5px', tablet: '.6px' },
      }}
    >
      {text}
    </Typography>
  );
};

export default HeaderTypography;
